const updates = [
  {
    date: '2026-07-30',
    time: '14:22',
    title: '台北娜娜最新动态更新：独家视频及多角度分析',
    tag: '独家',
  },
  {
    date: '2026-07-30',
    time: '11:05',
    title: '莫里秀黑料新发现：51吃瓜团队获取最新一手资料',
    tag: '爆料',
  },
  {
    date: '2026-07-30',
    time: '09:30',
    title: '玩偶姐姐发布新内容，暗网吃瓜第一时间独家解读',
    tag: '视频',
  },
  {
    date: '2026-07-29',
    time: '20:15',
    title: '暗网吃瓜人物专题更新：本月最受关注人物榜单出炉',
    tag: '榜单',
  },
  {
    date: '2026-07-29',
    time: '16:48',
    title: '51吃瓜社区热帖：吃瓜群众热议台北娜娜近况',
    tag: '社区',
  },
  {
    date: '2026-07-29',
    time: '12:30',
    title: '莫里秀专题深度回顾：重要事件时间线全整理',
    tag: '回顾',
  },
  {
    date: '2026-07-28',
    time: '21:00',
    title: '玩偶姐姐粉丝见面会独家报道与现场直击',
    tag: '现场',
  },
  {
    date: '2026-07-28',
    time: '15:20',
    title: '暗网吃瓜新增台北娜娜完整视频合集入口',
    tag: '更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          最新吃瓜快讯
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          实时追踪，不错过每一条爆料
        </p>
        <div className="mt-8 relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 pl-12">
                <div className="absolute left-[11px] top-1.5 w-[17px] h-[17px] rounded-full border-2 border-primary-500 bg-background-100 flex-shrink-0"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs text-foreground-400">
                      {item.date} {item.time}
                    </span>
                    <span className="px-2 py-0.5 rounded-full bg-primary-500/10 text-xs text-primary-400 font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="mt-1 text-sm font-medium text-foreground-700 hover:text-primary-400 transition-colors line-clamp-1 cursor-pointer block"
                  >
                    {item.title}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}